"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calculator_1 = require("./calculator");
var i18next_1 = __importDefault(require("i18next"));
var ACKNOWLEDGEMENT_INFO = {
    missionsCompleted: {
        nameKey: "missions_completed",
        xp: calculator_1.MISSION_XP
    },
    diariesRecorded: {
        nameKey: "diaries_recorded",
        xp: calculator_1.DIARY_XP
    },
    cravingsRecorded: {
        nameKey: "cravings_recorded",
        xp: calculator_1.RESISTED_CRAVING_XP
    },
    wishlistItemsAdded: {
        nameKey: "wishlist_items",
        xp: calculator_1.WISHLIST_ITEM_XP
    },
    tipsFavourited: {
        nameKey: "tips_favourited",
        xp: calculator_1.TIP_FAVOURITE_XP
    },
    parkReactions: {
        nameKey: "park_reactions",
        xp: calculator_1.PARK_REACTION_RECEIVE_XP
    }
};
var Acknowledgement = /** @class */ (function () {
    function Acknowledgement(name, quantity, xp) {
        this.name = name;
        this.quantity = quantity;
        this.xp = xp;
    }
    Acknowledgement.Compare = function (oldAchievements, newAchievements) {
        var e_1, _a;
        if (JSON.stringify(oldAchievements) == JSON.stringify(newAchievements)) {
            return null;
        }
        var acknowledgements = [];
        try {
            for (var _b = __values(Object.keys(ACKNOWLEDGEMENT_INFO)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var oldValue = oldAchievements[key];
                var newValue = newAchievements[key];
                var quantity = newValue - oldValue;
                if (quantity <= 0) {
                    continue;
                }
                var info = ACKNOWLEDGEMENT_INFO[key];
                var acknowledgement = new Acknowledgement(i18next_1.default.t(info.nameKey), quantity, info.xp * quantity);
                acknowledgements.push(acknowledgement);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return acknowledgements.length == 0 ? null : acknowledgements;
    };
    return Acknowledgement;
}());
exports.default = Acknowledgement;
